export default function SocialAndroidOutline() {
  return (
    <div
      className="ion-icon-social-android-outline"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<g>
		<path d="M352,208v60.5V357h-22.5H313v15.5V424c0,4.4-3,7.9-7.3,8l0,0l-0.1,0c-0.1,0-0.2,0-0.3,0c-1.6,0-3.1-0.6-4.3-1.6l-0.1-0.1
			l-0.4-0.1c-2-1.6-3.4-4-3.4-6.2v-51.5V357h-15.5h-49H216v15.5V424c0,4.4-3.6,8-8,8s-8-3.6-8-8v-51.5V357h-15.5H160v-88.6V208H352
			 M368,192H144v76.4V358c0,6.9,5.5,15,12.4,15H184v51c0,13.3,10.7,24,24,24s24-10.7,24-24v-51h49v51c0,7.5,3.9,14.2,9.3,18.6
			c3.9,3.4,9.3,5.4,15,5.4c0.1,0,0.3,0,0.4,0c0.1,0-0.3,0-0.2,0c13.3,0,23.6-10.7,23.6-24v-51h28.6c7,0,10.4-8.1,10.4-14.9v-89.6
			V192L368,192z"/>
		<path d="M408,192c4.4,0,8,3.6,8,8v96c0,4.4-3.6,8-8,8s-8-3.6-8-8v-96C400,195.6,403.6,192,408,192 M408,176c-13.3,0-24,10.7-24,24
			v96c0,13.3,10.7,24,24,24s24-10.7,24-24v-96C432,186.7,421.3,176,408,176L408,176z"/>
		<path d="M104,192c4.4,0,8,3.6,8,8v96c0,4.4-3.6,8-8,8s-8-3.6-8-8v-96C96,195.6,99.6,192,104,192 M104,176c-13.3,0-24,10.7-24,24
			v96c0,13.3,10.7,24,24,24s24-10.7,24-24v-96C128,186.7,117.3,176,104,176L104,176z"/>
	</g>
	<g>
		<path d="M255,94.3l0.9,0h0h0c14.2,0,27.3,1.9,38.8,5.6l10,4.4c28.7,12.6,39.9,37.4,44.4,55.7H162.8c4.4-18.6,15.6-43.6,44.1-56
			l10.3-4.5C228.5,96.1,241.2,94.3,255,94.3 M185.4,64c-0.5,0-1.2,0.2-1.8,0.8c-1.1,0.8-1.7,1.8-1.3,2.5l18.3,22.1
			c-48.2,20.9-55.4,71.7-56.4,86.7h223.6c-1.1-15-8.2-65.1-56.6-86.4l18.5-22.2c0.4-0.5-0.2-1.7-1.3-2.6c-0.7-0.5-1.5-0.8-2-0.8
			c-0.3,0-0.5,0.1-0.7,0.3l-19.2,22.7c-13.6-5.4-30.2-8.8-50.6-8.8c-0.3,0-0.6,0-1,0c-20,0-36.4,3.3-49.8,8.5l-19-22.5
			C186.1,64.1,185.8,64,185.4,64L185.4,64z"/>
	</g>
</g>
<path d="M206.6,138.9c-7.4,0-13.5-6-13.5-13.3c0-7.3,6-13.3,13.5-13.3c7.4,0,13.5,6,13.5,13.3C220.1,132.9,214.1,138.9,206.6,138.9z
	"/>
<path d="M305,138.9c-7.4,0-13.5-6-13.5-13.3c0-7.3,6-13.3,13.5-13.3c7.4,0,13.5,6,13.5,13.3C318.5,132.9,312.4,138.9,305,138.9z"/>
</svg>
`,
      }}
    />
  )
}
